import { ObservableArray, View } from "binder"
import { productForSelector, ProductSearchableSelectorViewModel } from "./productSearchableSelector-viewModel"
import { CarBrandSelectorViewModel } from "src/Warehouse/carBrandManipulation/carBrandManipulation-viewModel";
import { CarModelSelectorViewModel } from "src/Warehouse/carModelManipulation/carModelManipulation-viewModel";

export class ProductSearchableSelectorView extends View<ProductSearchableSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-3A724271-2C12-4DD5-A49A-58346D1BB6EE"
    }
    loadHtml(): string {
        let element = require('./productSearchableSelector.html').default;
        let style = require('./productSearchableSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set items(v: ObservableArray<productForSelector>) { this._items = v; } public get items(): ObservableArray<productForSelector> { return this._items;} private _items: ObservableArray<productForSelector>;
    public set selectedItem(v: productForSelector) { this._selectedItem = v; } public get selectedItem(): productForSelector { return this._selectedItem;} private _selectedItem: productForSelector;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set searchedText(v: string) { this._searchedText = v; } public get searchedText(): string { return this._searchedText;} private _searchedText: string;
    public set isShowingPopup(v: boolean) { 
        this._isShowingPopup = v;
        if(v && this.popup_container)
            this.preferredWidth = this.popup_container.clientWidth.toString()+"px";
    } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set isAdvancedSearch(v: boolean) { this._isAdvancedSearch = v; } public get isAdvancedSearch(): boolean { return this._isAdvancedSearch;} private _isAdvancedSearch: boolean;
    public set showAdvancedSearch(v: boolean) { this._showAdvancedSearch = v; } public get showAdvancedSearch(): boolean { return this._showAdvancedSearch;} private _showAdvancedSearch: boolean;
    public set preferredWidth(v: string) { this._preferredWidth = v; } public get preferredWidth(): string { return this._preferredWidth;} private _preferredWidth: string;
    public set popup_container(v: HTMLElement) { this._popup_content = v; } public get popup_container(): HTMLElement { return this._popup_content;} private _popup_content: HTMLElement;
    
    public set carModelId(v: string) { this._carModelId = v; } public get carModelId(): string { return this._carModelId;} private _carModelId: string;
    public set carModelName(v: string) { this._carModelName = v; } public get carModelName(): string { return this._carModelName;} private _carModelName: string;
    public set carModelCode(v: string) { this._carModelCode = v; } public get carModelCode(): string { return this._carModelCode;} private _carModelCode: string;
    public set carBrandSelector(v: CarBrandSelectorViewModel) { this._partNumberSelector = v; } public get carBrandSelector(): CarBrandSelectorViewModel { return this._partNumberSelector;} private _partNumberSelector: CarBrandSelectorViewModel;
    public set carModelSelector(v: CarModelSelectorViewModel) { this._carModelSelector = v; } public get carModelSelector(): CarModelSelectorViewModel { return this._carModelSelector;} private _carModelSelector: CarModelSelectorViewModel;
        
    
    onkeydown(e:KeyboardEvent){
        if(e.key=="Enter"){
            this.refresh();
        }
    }
    public onRenderCompleted() {
        this.popup_container = this.firstlevelElement.querySelector("#V-41490DFA-051F-45BA-88F0-AFD2585640E0-popup-container");
        this.preferredWidth = this.popup_container.clientWidth.toString()+"px";
    }
    refresh(){
        this.dataContext.refresh();
    }
    
    advancedSearch(){
        this.dataContext.advancedSearch();
    }
    
    clearAdvancedSearch(){
        this.dataContext.clearAdvancedSearch();
    }

    requestNew(){
        this.dataContext.requestNew();
    }
}
